export default __webpack_public_path__ + "static/media/profile.b889b7b8.svg";